export default "/images/vendor/flag-icons/flags/1x1/at.svg?5ffa25ce96dad1a8c4dc82bcc2fd3fba";